import { ApplicationRef, Injectable } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { environment } from 'environments/environment';
import { Socket } from 'ngx-socket-io';

@Injectable({
    providedIn: 'root',
})
export class SocketService extends Socket {
    constructor(_authService: AuthService, appRef: ApplicationRef) {
        super(
            {
                url: environment.apiUrl,
                options: {
                    autoConnect: false,
                    query: {
                        token: _authService.accessToken,
                        platform: 'web',
                    },
                    transports: ['websocket'],
                    withCredentials: true,
                },
            },
            appRef
        );
    }
}
